import { useMemo } from 'react';
import type { FC } from 'react';

import type { ProviderAccessMap } from '@vgtv/svp-access/lib/access_mappings';
import type { Provider } from '@vgtv/api-client';
import { User as UserIcon } from '@vgno/icons';
import classNames from 'classnames';

import { Circle } from '../../../Circle/Circle';
import { PlusIcon, UnknownIcon } from '../../../Icon/Icon';

import * as styles from './UserAvatar.module.scss';

interface Props {
  initials?: string;
  isLoggedIn?: boolean;
  access?: ProviderAccessMap[Provider][];
  className?: string;
}

export const UserAvatarBase: FC<Props> = (props) => {
  const { initials, isLoggedIn, access = [], className } = props;

  const content = isLoggedIn ? (
    <div className={styles.initials}>{initials}</div>
  ) : (
    <UserIcon className={styles.userIcon} />
  );

  const icon = useMemo(() => {
    if (isLoggedIn) {
      if (access.includes('plus') || access.includes('sport'))
        return <PlusIcon className={styles.subscriber} />;
    } else {
      return <UnknownIcon className={styles.unknown} />;
    }
  }, [isLoggedIn, access]);

  return (
    <div className={classNames(styles.container, className)}>
      <Circle>{content}</Circle>
      {icon && <Circle className={styles.satellite}>{icon}</Circle>}
    </div>
  );
};
